import React, { useEffect, useState } from 'react';
import { Box, Slide, Stack, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import UndoIcon from '@mui/icons-material/Undo';

interface UndoToastProps {
  message: string | null;
  onUndo?: () => void;
  onDismiss?: () => void;
  /** ms — default 5 sec */
  duration?: number;
}

const UndoToast: React.FC<UndoToastProps> = ({
  message,
  onUndo,
  onDismiss,
  duration = 5000,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message) {
      setOpen(true);
      const t = setTimeout(() => {
        setOpen(false);
        onDismiss?.();
      }, duration);
      return () => clearTimeout(t);
    }
    setOpen(false);
    return undefined;
  }, [message, duration, onDismiss]);

  if (!message) return null;

  return (
    <Slide in={open} direction={'up'} mountOnEnter unmountOnExit>
      <Box
        sx={{
          bgcolor: 'grey.900',
          borderRadius: 2,
          bottom: 28,
          boxShadow: '0 18px 44px -16px rgba(20,20,20,0.6)',
          color: 'common.white',
          left: '50%',
          maxWidth: 'calc(100vw - 32px)',
          position: 'fixed',
          transform: 'translateX(-50%)',
          zIndex: 1400,
        }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={1.75}
          sx={{
            p: '12px 16px 12px 18px',
          }}
        >
          <DeleteOutlineIcon sx={{ color: 'common.white', fontSize: 20 }} />
          <Typography sx={{ fontSize: 14.5, fontWeight: 600 }}>
            {message}
          </Typography>
          {onUndo && (
            <Box
              component={'button'}
              onClick={onUndo}
              sx={{
                alignItems: 'center',
                background: 'transparent',
                border: 'none',
                color: '#3FE0CE',
                cursor: 'pointer',
                display: 'inline-flex',
                fontFamily: 'inherit',
                fontSize: 14,
                fontWeight: 800,
                gap: 0.5,
                p: '0 4px',
                '&:hover': { opacity: 0.85 },
              }}
            >
              <UndoIcon sx={{ fontSize: 18 }} />
              {'Відмінити'}
            </Box>
          )}
        </Stack>
      </Box>
    </Slide>
  );
};

export default UndoToast;
